import CrudActionSetBase from './CrudActionSetBase'

export class GxpActionSet extends CrudActionSetBase('gxp'){
}
export default new GxpActionSet()